var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.599,
    height: 22.846,
    viewBox: "0 0 18.599 22.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apple",
    d: "M16.516,5.644A5,5,0,0,0,17.727,2,5.071,5.071,0,0,0,14.3,3.736a4.763,4.763,0,0,0-1.142,3.529A4.215,4.215,0,0,0,16.516,5.644Zm2.878,8.5A5.151,5.151,0,0,1,21.861,9.79a5.323,5.323,0,0,0-4.18-2.284c-1.782-.183-3.427,1.039-4.375,1.039s-2.284-1.017-3.769-.994a5.62,5.62,0,0,0-4.729,2.89c-2.01,3.5-.514,8.692,1.5,11.513.914,1.382,2.056,2.947,3.564,2.89s2-.937,3.746-.937,2.284.937,3.769.9,2.536-1.416,3.5-2.8a12.564,12.564,0,0,0,1.576-3.255,5.037,5.037,0,0,1-3.061-4.615Z",
    transform: "translate(-3.856 -2)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.d28f9f25a34803769d7f55a3a5796398.svg";
export { ForwardRef as ReactComponent };